import React from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import Hero from "../components/Appdevelopment/Hero";
import DevelopServices from "../components/Appdevelopment/DevelopServices";
import Technology from "../components/Appdevelopment/Technology";
import Process from "../components/Appdevelopment/Process";
import IndustryBussinessjs from "../components/Appdevelopment/IndustryBussinessjs";
import Commitment from "../components/Appdevelopment/Commitment";
import Customers from "../components/Appdevelopment/Customers";
import Success from "../components/Appdevelopment/Success";
import PageTitle from "../components/Appdevelopment/PageTitle";

import '../assets/Webdevelopment.css';



const Appdevelopment = () => {
	return(
		<div className="App">
			<PageTitle />
	    	<Hero />
	    	<DevelopServices />
	    	<Technology />
	    	<Process />
	    	<IndustryBussinessjs />
	    	<Commitment />
	    	<Customers/>
	    	<Success />
	  </div>
	)
}

export default Appdevelopment;
